import DataService from '../data.service';
class PredmetiAPI {
    list(pagination = { page: 1, pageSize: 25 }, filter = {}, sort = {}) {
        return DataService.get('predmet', { pagination, filter, sort })
    }
}

export default new PredmetiAPI();